import { Instagram } from "lucide-react";
import { SITE, NAV_LINKS } from "@/data/site";
import CloudinaryImage from "@/components/CloudinaryImage";

export default function Footer() {
  return (
    <footer
      className="relative bg-[#050d0a] text-white/80 pt-24 pb-10"
      data-testid="site-footer"
    >
      <div className="container-pam grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="relative inline-block max-w-[320px]">
            <CloudinaryImage
              publicId={SITE.cloudinary.logoFooter}
              fallback={SITE.logoFooter}
              alt="Peak Adventures Malnad"
              className="h-16 md:h-20 w-auto object-contain"
              eager
              data-testid="footer-logo"
            />
          </div>
          <p className="mt-8 max-w-sm text-sm font-light leading-relaxed text-white/60">
            Peak Adventures Malnad is a trusted travel curator — connecting
            travellers to handpicked partner homestays and curated experiences
            across Chikkamagaluru, Mudigere, Kalasa and Sakleshpur.
          </p>
          <div className="mt-8 flex items-center gap-3">
            <a
              href={SITE.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="w-11 h-11 rounded-full border border-white/15 grid place-items-center hover:text-[var(--pam-gold)] hover:border-[var(--pam-gold)] transition-colors"
              aria-label="Instagram"
              data-testid="footer-instagram"
            >
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--pam-gold)]">
            Explore
          </div>
          <ul className="mt-5 space-y-2.5 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="hover:text-[var(--pam-gold)] transition-colors"
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--pam-gold)]">
            Contact
          </div>
          <ul className="mt-5 space-y-2.5 text-sm">
            <li>
              <a
                href={`tel:+${SITE.phoneE164}`}
                className="hover:text-[var(--pam-gold)] transition-colors"
              >
                {SITE.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${SITE.email}`}
                className="hover:text-[var(--pam-gold)] break-all transition-colors"
              >
                {SITE.email}
              </a>
            </li>
            <li className="text-white/60 pt-1">{SITE.address}</li>
          </ul>
        </div>
      </div>

      <div className="container-pam mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
        <span>
          © {new Date().getFullYear()} {SITE.brand}. All rights reserved. Made
          by{" "}
          <a
            href={SITE.creditUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[var(--pam-gold)] hover:underline"
            data-testid="footer-credit-link"
          >
            {SITE.creditName}
          </a>
          .
        </span>
        <span>Crafted in the Western Ghats · Karnataka, India</span>
      </div>
    </footer>
  );
}
